<div *ngIf="!vm.workingText && !vm.errorText">
    <!-- Mobile -->
    <div class="d-block d-md-none">
        <div *ngFor="let r of vm.rows">
            <div class="container">
                <mdb-card cascade="true" narrower="true" class="pt-3">
                    <div class="row" *ngIf="mobileModeTitleCol >= 0">
                        <div class="col-9 col-sm-8">
                            <div class="view view-cascade gradient-card-header blue-gradient narrower pb-0 pt-2">
                                <h4 class="card-header-title">{{r[mobileModeTitleCol]}}</h4>
                            </div>
                        </div>
                    </div>
                    <mdb-card-body cascade="true" class="pb-0 px-2">
                        <mdb-card-text>
                            <div *ngFor="let f of r; index as i">
                                <div class="row" *ngIf="i != mobileModeTitleCol">
                                    <div class="col-5 text-right"><b>{{vm.columns[i]}}:</b></div>
                                    <div class="col-7"><strong>{{f}}</strong></div>
                                </div>
                            </div>
                        </mdb-card-text>
                    </mdb-card-body>
                </mdb-card>
            </div>
        </div>
    </div>

    <!-- Desktop-->
    <div class="d-none d-md-block">
        <mdb-card narrower="true" cascade="true" class="py-2">
            <mdb-card-title>
                <div *ngIf="title" class="view view-cascade overlay gradient-card-header blue-gradient py-2">
                    <h1 *ngIf="headingSize1" class="h1-responsive mb-0">
                        <span>{{title}}</span>
                    </h1>
                    <h2 *ngIf="headingSize2" class="h2-responsive mb-0">
                        <span>{{title}}</span>
                    </h2>
                    <h3 *ngIf="headingSize3" class="h3-responsive mb-0">
                        <span>{{title}}</span>
                    </h3>
                    <h4 *ngIf="headingSize4" class="h4-responsive mb-0">
                        <span>{{title}}</span>
                    </h4>
                    <h5 *ngIf="headingSize5" class="h5-responsive mb-0">
                        <span>{{title}}</span>
                    </h5>
                    <small *ngIf="subTitle">
                        {{subTitle}}
                    </small>
                </div>
            </mdb-card-title>
            <mdb-card-body cascade="true" class="py-0">
                <div class="row">
                    <div class="px-5 py-0">
                        <table *ngIf="vm.rows.length" mdbTable striped="true" small="true" class="z-depth-1">
                            <thead>
                                <tr>
                                    <th scope="col" *ngFor="let c of vm.columns">{{c}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr mdbTableCol *ngFor="let r of vm.rows">
                                    <td class="h6" *ngFor="let f of r">{{f}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </mdb-card-body>
        </mdb-card>
    </div>
</div>